<template>
  <vs-popup class="popup-post-viewer" :title="title" :active.sync="showPopup">
    <div class="popup-post-viewer-container">
      <div class="p-6 overflow-y-auto">
        <component
          class="w-full h-full"
          :is="componentWrite"
          :_postId="`${postId}`"
          :parentId="parentId"
          :board="{
              projectTitle: '',
              writer: {}, //작성자 정보
              readonly: true, // 읽기전용인가
              viewSaveBtn: false,
            }"
          :header="header"
          :value="body"
          v-bind="options"
        />
      </div>
      <div>
        <slot name="foot" :close="() => { showPopup = false }"></slot>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import singlePageWrite from "@/views/boards/single-page/writeIndex";

export default {
  name: "PopupPostViewer",
  props: {
    title: String,
    value: Boolean,
    postId: [Number, String],
    boardId: Number,
    parentId: Number,
    header: Object,
    body: Object,
    // 특정 게시판(Write 컴포넌트)에만 필요한 추가 옵션을 그대로 전달하기 위한 통로
    // (예: 813/814의 forceShowImprovement) — PopupPostViewer는 내용을 모르는 채로 그대로 넘겨줌
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    componentWrite() {
      if (singlePageWrite[`${this.boardId}_write`]) {
        const component = singlePageWrite[`${this.boardId}_write`];
        return component;
      }
    },
    showPopup: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

}
</script>

<style scoped>
.popup-post-viewer-container {
  position: absolute;
  top: 40px; bottom: 0;
  left: 0; right: 0;

  display: grid;
  grid-template-rows: 1fr auto;

  overflow: hidden;
}
</style>

<style lang="scss">
.popup-post-viewer.con-vs-popup {

  .vs-popup {
    width: 80% !important;
  }


  .vs-popup--content {

    padding: 0;
    margin: 0;
    overflow: hidden;

    width: 100%;
    height: 1100px;
    max-height: 90% !important;
  }
}
</style>
